import * as React from 'react'
import { ReactElement, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { MenuItemKey } from '../../components/Menu'
import { Store } from '../../reducers'
import { DataPromise, shouldDispatchLoad } from '../../context/AxiosContext'
import TaskOverview from './TaskOverview'
import { taskBaseUrl } from '../Tasks'
import { FileAction } from '../../config/fileConfig'
import { AppAction } from '../../config/appConfig'
import { TaskAction, TaskOverviewDto } from '../../config/taskConfig'
import { TaskListSettings } from '../../components/List/Task/TaskList'
import useAxios from '../../hooks/useAxios'

export default function GlobalTaskOverview(props): ReactElement {
    const axios = useAxios()
    const dispatch = useDispatch()
    const tasks = useSelector<Store, DataPromise<TaskOverviewDto[], TaskListSettings>>(state => state.tasks.overview)

    useEffect(() => {
        dispatch({ type: AppAction.SetBreadcrumbs, payload: [MenuItemKey.Tasks] })
        dispatch({ type: FileAction.ResetCurrent })
    }, [props])

    useEffect(() => {
        if (shouldDispatchLoad(tasks)) {
            dispatch({
                type: TaskAction.GetOverview,
                payload: axios.get('/task', { params: tasks.settings }),
            })
        }
    }, [tasks])

    return (
        <TaskOverview
            setDefaultAssignee={true}
            baseUrl={taskBaseUrl}
            data={tasks.data}
            reset={() =>
                dispatch({
                    type: TaskAction.GetOverview,
                    payload: axios.get('/task'),
                })
            }
            global
        />
    )
}
